/** @jsx jsx */
import { jsx } from '@emotion/react';
import { connectStats } from 'react-instantsearch-dom';
import { SearchStats } from '../Stats';

export default connectStats(({ nbHits, ...rest }) => <SearchStats hits={nbHits} {...rest} />);
